import React from "react";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import SecondaryNav from "../../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminLearningMenu,
  LearningMatrixNav,
} from "../../../../components/AdminComponents/MenuItems";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import { useSelector } from "react-redux";
import { Pagination, Popover, Table, Tag } from "antd";
import { remainingViewportHeight } from "../../../../components/icons/ApplicationColor";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";

const CourseRoles = () => {
  const userInfo = useSelector((state) => state.user);
  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // handleSwitchChange,
    // setFilterData,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 15,
    passPage: 1,
    passURL: `learn/coursematrix/?organization_id=${userInfo.data.organization.id}`,
    // loadAgain: loadAgain,
    // includeStatus: false,
  });
  const { pageSize, currentPage } = filterData;
  const columns = [
    {
      title: "Course Id",
      width: 120,
      render: (text, record, index) => {
        return (
          //   <Link
          //     to={`/track/learning-matrix/${roleMatrix?.data[index]?.id}/${roleMatrix?.data[index]?.course[0]?.id}`}
          //   >
          <div>
            <span className="text-primary">{record?.course_id}</span>
          </div>
          //   </Link>
        );
      },
    },
    {
      title: "Course Name",
      width: 170,
      render: (text, record, index) => {
        return (
          <p className="active-status text-truncate m-0">
            <div className="text-truncate">{record?.name}</div>
          </p>
        );
      },
    },
    {
      title: "Mode",
      width: 120,

      render: (text, record, index) => {
        return (
          <p className="active-status text-truncate m-0">
            <div className="text-truncate">{record?.mode}</div>
          </p>
        );
      },
    },
    {
      title: "License",
      width: 90,
      className: "px-0",
      render: (text, record, index) => {
        return (
          <p className="active-status text-truncate m-0">
            {record.license ? "Yes" : "No"}
          </p>
        );
      },
    },
    {
      title: "Type",
      width: 120,
      className: "px-0",
      render: (text, record, index) => {
        return (
          <p className="active-status text-truncate m-0">
            <div className="text-truncate">{record?.type}</div>
          </p>
        );
      },
    },
    {
      title: "Work Role ID",
      width: 120,
      className: "px-0",
      render: (text, record, index) => {
        return (
          <div>
            {record?.work_role
              ? record?.work_role?.map((val) => (
                  <p
                    className="table-divider text-truncate m-0 text-primary"
                    key={val.id}
                    //   onClick={() => openRole(roleMatrix.data[index], val)}
                  >
                    <span className="text-primary">{val?.role_id}</span>
                  </p>
                ))
              : null}
          </div>
        );
      },
    },
    {
      title: "Work Role name",
      width: 300,
      className: "px-0",
      render: (text, record, index) => {
        return (
          <div>
            {record?.work_role
              ? record?.work_role.map((val) => (
                  <p
                    className="table-divider text-truncate m-0"
                    key={val.id}
                    // onClick={() => openRole(roleMatrix.data[index], val)}
                  >
                    <div className="ellipsis">{val?.name}</div>
                  </p>
                ))
              : null}
          </div>
        );
      },
    },

    {
      title: "No of Users",
      width: 250,
      className: "px-0",
      render: (text, record, index) => {
        const courses = data?.[index]?.work_role || [];

        return (
          <div className="p-0">
            {courses.map((val) => {
              const hasCounts =
                val?.employee_count &&
                Object.entries(val.employee_count)
                  .filter(([key]) => key !== "all_tr")
                  .some(([, num]) => num > 0);

              if (!hasCounts) return null;

              return (
                <div className="table-divider status-list" key={val.id}>
                  {val?.employee_count.expired > 0 && (
                    <Popover content={`${val?.employee_count.expired} Expired`}>
                      <Tag color="error" className="user-status-tag">
                        {val?.employee_count.expired}
                      </Tag>
                    </Popover>
                  )}

                  {val?.employee_count.expiring_soon > 0 && (
                    <Popover
                      content={`${val?.employee_count.expiring_soon} Expiring Soon`}
                    >
                      <Tag color="warning" className="user-status-tag">
                        {val?.employee_count.expiring_soon}
                      </Tag>
                    </Popover>
                  )}

                  {val?.employee_count.no_training_record > 0 && (
                    <Popover
                      content={`${val?.employee_count.no_training_record} No Learning Record`}
                    >
                      <Tag color="default" className="user-status-tag">
                        {val?.employee_count.no_training_record}
                      </Tag>
                    </Popover>
                  )}

                  {val?.employee_count.ongoing > 0 && (
                    <Popover
                      content={`${val?.employee_count.ongoing} Scheduled`}
                    >
                      <Tag color="processing" className="user-status-tag">
                        {val?.employee_count.ongoing}
                      </Tag>
                    </Popover>
                  )}

                  {val?.employee_count.valid > 0 && (
                    <Popover content={`${val?.employee_count.valid} Valid`}>
                      <Tag color="success" className="user-status-tag">
                        {val?.employee_count.valid}
                      </Tag>
                    </Popover>
                  )}
                </div>
              );
            })}
          </div>
        );
      },
    },
  ];
  return (
    <CaSideNav props={CaAdminLearningMenu}>
      <SecondaryNav menuItems={LearningMatrixNav} />
      <CommonTopDetails
        title={`Course Matrix Summary`}
        titleSuffix={`${itemsLength || 0} row(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={true}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () => {},
        }}
      />
      <div className="matrix-container">
        <Table
          dataSource={data}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          loading={loading}
          columns={columns}
          rowKey={(record) => record.id}
          pagination={false}
          scroll={{
            x: 1000,
            y: `${remainingViewportHeight(29)}px`,
          }}
          style={{ margin: "1rem" }}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
    </CaSideNav>
  );
};

export default CourseRoles;
